import { render, staticRenderFns } from "./PurchaseTransactions.vue?vue&type=template&id=1d27688e&scoped=true"
import script from "./PurchaseTransactions.vue?vue&type=script&lang=js"
export * from "./PurchaseTransactions.vue?vue&type=script&lang=js"
import style0 from "./PurchaseTransactions.vue?vue&type=style&index=0&id=1d27688e&prod&scoped=true&lang=css"
import style1 from "./PurchaseTransactions.vue?vue&type=style&index=1&id=1d27688e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d27688e",
  null
  
)

export default component.exports